<script lang="ts">
import AppButton from '@/components/v2/AppButton.vue';

export default {
  name: 'NotFound',
  components: { AppButton },
};
</script>

<script setup lang="ts">
import src from '@/assets/images/not_found.svg';

defineProps<{
  subText?: string;
}>();
</script>

<template>
  <div class="tw:grid tw:grid-cols-[0.4fr] tw:content-center tw:items-center tw:justify-center tw:justify-items-center tw:h-[60vh]">
    <img :src="src" alt="Not Found" class="tw:mx-auto tw:w-full tw:h-auto tw:max-h-[30vh]" />
    <h2 class="tw:mt-4 tw:text-center">Not Found</h2>
    <p class="tw:text-center">{{ subText }}</p>
    <router-link to="/" class="tw:text-center">
      <AppButton primary>Go Home</AppButton>
    </router-link>
  </div>
</template>
